<div class="col-12 mb-2">
    <form [formGroup]="commentsFrm">
        <label class="col-form-label">Comments <app-required-label *ngIf="mode === 'UPDATE'"></app-required-label></label>
        <textarea pInputTextarea rows="2" cols="10" class="form-control form-control-sm" formControlName="comments" maxlength="maxCommentsLength" [ngClass]="{'is-invalid': isControlInvalid(f.comments)}"></textarea>
        <app-error [isSubmit]="submit" [caption]="'Comments'" [control]="f.comments" class="invalid-feedback"></app-error>
    </form>
</div>
<div class="col-12 mb-2 mt-5" *ngIf="notesList.length > 0">
    <h6 class="commentHistory">Comments History</h6>
    <app-ui-table [data]="notesList" [headers]="noteHeaders" [showExport]="false"></app-ui-table>
</div>